import React from 'react';

import { Colors } from '@nakedplatform/ui';
import { Routes } from 'routes';
import { NakedIcon } from 'theme/icons';

import { LogoLinkContainer } from './styles';

/**
 * `Logo` is a functional component that renders a logo in the footer.
 * The logo is hidden on screens smaller than 1024px and is displayed on larger screens.
 * Clicking on the logo redirects the user to the home page.
 *
 * @example
 * return (
 *   <Logo />
 * )
 */
export function Logo() {
  return (
    <LogoLinkContainer aria-label="Go to home page" href={Routes.HOME}>
      <NakedIcon name="naked-logo" color={Colors.grey600} size={26.5} />
    </LogoLinkContainer>
  );
}
